import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { RouteComponentProps } from 'react-router'
import { AppState, Dispatch } from 'store/types'
import {
  fetchRelationships,
  fetchGenders,
  fetchAppointments,
  fetchPatients,
  fetchPhysicians,
  fetchServiceAreas,
  fetchCpt4Codes,
  fetchConfiguration
} from 'ducks/references/operations'
import { createEstimate, createPublicEstimate } from 'ducks/estimates/operations'
import { Button } from 'components/UI/Button'
import { Link } from 'components/UI/Link'
import { Modal } from 'components/UI/Modal'
import EstimateForm from 'components/estimates/EstimateForm'
import { handleErrorMessageAlert } from 'components/UI/Alert'
import { camelCaseToSentence } from 'utils/helpers'
import { routePath, history } from 'routes'
import {
  Counter,
  HeadTitle,
  ModalContent,
  Step,
  StepProgress,
  Title,
  WrapBlock
} from './styles'

import { DEPARTMENT_ID } from '../../constants'
import { AppointmentVariant } from 'ducks/references/types'

interface UserInfo {
  dob?: string
  firstName?: string
  gender?: { value: number; label: string } | string
  lastName?: string
  middleInitial?: string
  relationship?: { value: number; label: string } | string
}

interface NumbersArray {
  [index: string]: number | string
}

interface Form extends UserInfo {
  payer?: { value: number; label: string; dobRequired: boolean; fakeEligibility: boolean; requiredMemberId: boolean } | string
  memberId?: string
  dependent?: UserInfo
  appointmentType?: string
  appointmentIdSet?: NumbersArray
  appointmentList?: any[]
  cpt4Id?: BigInteger
  cpt4IdSet?: NumbersArray
  cpt4List?: any[]
  physician?: { value: number; label?: string } | string
}

interface IFormState {
  currentStep: number
  showModal: boolean
  form?: Form
  errors: any
  showPatientSubscriber: boolean
}

const breadCrumbs = ['Insurance Info', 'Patient Info', 'Procedure Info']
const pages = ['Insurance Info', 'Patient Info', 'Procedure Info']
const enableGender = process.env.REACT_APP_ENABLE_GENDER === 'true'

function formatDate(date: string): string {
    const [ year, month, day ] = date.split('-');
    return `${month}/${day}/${year}`;
}

class EstimateCreatePage extends Component<Props, IFormState> {
  constructor(props: Props) {
    super(props)
    const { publicEstimate } = props;
    console.log(publicEstimate)
    if (!!Object.keys(publicEstimate).length) { // In case user is comming back from estimate calculation
        this.state = {
          currentStep: 0,
          showModal: false,
          form: {
            payer: { 
                value: publicEstimate.payer.id,
                label: publicEstimate.payer.carrierName,
                dobRequired: publicEstimate.payer.dobRequired,
                fakeEligibility: publicEstimate.payer.fakeEligibility,
                requiredMemberId: publicEstimate.payer.requiredMemberId,
            },
            memberId: publicEstimate.memberId,
            dependent: !!Object.keys(publicEstimate.dependentEntity).length ? {
                dob: publicEstimate.dependentEntity.dob ? formatDate(publicEstimate.dependentEntity.dob) : '',
                firstName: publicEstimate.dependentEntity.firstName,
                gender: publicEstimate.dependentEntity.gender,
                lastName: publicEstimate.dependentEntity.lastName,
                middleInitial: publicEstimate.dependentEntity.middleInitial,
            } : {
                dob: publicEstimate.dob ? formatDate(publicEstimate.dob) : '',
                firstName: publicEstimate.firstName,
                lastName: publicEstimate.lastName,
                middleInitial: publicEstimate.middleInitial, //@ts-ignore
                gender: { value: publicEstimate.gender, label: publicEstimate.gender }, //@ts-ignore
            },
            cpt4List: publicEstimate.cpt4EntitySet.map(({ id, cpt4Code, description }: { id: number, cpt4Code: string, description: string }) => ({ 
                value: id,
                label: `${cpt4Code} - ${description}`,
                cpt4Id: id
            })),
            cpt4IdSet: { value: publicEstimate.cpt4EntitySet[0].id, label: `${publicEstimate.cpt4EntitySet[0].cpt4Code} - ${publicEstimate.cpt4EntitySet[0].description}` },
            dob: publicEstimate.dob && publicEstimate.dependentSearch ? formatDate(publicEstimate.dob) : '',
            firstName: publicEstimate.dependentSearch ? publicEstimate.firstName : '',
            lastName: publicEstimate.dependentSearch ? publicEstimate.lastName : '',
            middleInitial: publicEstimate.middleInitial, //@ts-ignore
            gender: publicEstimate.dependentSearch ? { value: publicEstimate.gender, label: publicEstimate.gender } : '', //@ts-ignore
            relationship: publicEstimate.dependentSearch ? { value: publicEstimate.relationship, label: publicEstimate.relationship } : '',
            physician: { value: publicEstimate.physicianId }
          },
          errors: {},
          showPatientSubscriber: !publicEstimate.dependentSearch
        }
    } else {
        this.state = {
          currentStep: 0,
          showModal: false,
          form: {
            payer: '',
          },
          errors: {},
          showPatientSubscriber: true
        }
    }
  }

  componentDidMount(): void {
    this.props.fetchRelationships()
    this.props.fetchGenders()
    this.props.fetchAppointments()
    this.props.fetchPatients()
    this.props.fetchPhysicians()
    this.props.fetchCpt4Codes()
    this.props.fetchConfiguration()
  }

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<IFormState>,
    snapshot?: any
  ): void {
    if (prevProps.isCreating && !this.props.isCreating && this.props.error) {
      handleErrorMessageAlert('Not all data is entered')
    }
  }

  onUpdate = () => { }
  showModal = () => this.setState({ showModal: true })
  onCloseModal = () => this.setState({ showModal: false })
  onSubmit = () => {
    console.log("Voy por aqui")
    this.createEstimate1();
  }

  onChangeInput = (name: string, value: string | null): void => {
    console.log("onChangeInput", name, value)
    const nameArr = name.split('.')
    console.log(value)
    const getValue = (state: any) =>
      nameArr && nameArr.length === 2
        ? {
          [nameArr[0]]: {
            ...state[nameArr[0]],
            [nameArr[1]]: value
          }
        }
        : { [nameArr[0]]: value }
    // @ts-ignore
    const getValidate = (name: string) =>
      name === 'dependent.firstName' ||
        name === 'dependent.lastName' ||
        name === 'dependent.middleInitial' ||
        name === 'dependent.dob'
        ? { [`${nameArr[1]}2`]: '' }
        : { [nameArr[0]]: '' }

    if (name === 'cpt4Id') {
      // @ts-ignore
      var { cpt4List } = this.state.form
//      cpt4List = cpt4List || []
      cpt4List = []
      // @ts-ignore
      cpt4List.push({ cpt4Id: value.value, label: value.label })
      // @ts-ignore
      const cpt4IdSet = { value: value.value, label: value.label }
      console.log("CPT4List", cpt4List)
      console.log("form", this.state.form)
      this.setState(state => ({
        ...state,
        form: {
          ...state.form,
          ...getValue(state.form),
          cpt4List,
          cpt4IdSet
        },
        errors: { ...state.errors, ...getValidate(name) } // [`${name}2`]: '' // ...getValidate(name)
      }))
      console.log("State is ", this.state.form)
    } else {
      this.setState(state => ({
        ...state,
        form: {
          ...state.form,
          ...getValue(state.form)
        },
        errors: { ...state.errors, ...getValidate(name) } // [`${name}2`]: '' // ...getValidate(name)
      }))
      console.log("props", this.props)
      console.log('this.state', this.state, name, name === 'dependent.firstName')
    }
  }

  onRemoveElement = (id: any): void => {
    if (id) {
        console.log("onRemoveElement ", id, this.state)

      // @ts-ignore
      const appointmentName = this.state.form.cpt4Id ? 'cpt4Id' : 'appointmentId'

      console.log("appointmentName", appointmentName)
      // @ts-ignore
      const appointmentList = appointmentName === 'appointmentId' && this.state.form.appointmentList  ? this.state.form.appointmentList.filter(item => item.appointmentId !== id) : []

      // @ts-ignore
      const cpt4List = appointmentName === 'cpt4Id' && this.state.form.cpt4List ? this.state.form.cpt4List.filter(item => item.cpt4Id !== id) : []
      console.log("after cpt4List", cpt4List)
      this.setState(state => ({
        ...state,
        form: {
          ...state.form,
          cpt4List,
          appointmentList
        },
        errors: { ...state.errors }
      }))
    }
  }

  validateByStep = (step: number) => {
    // @ts-ignore
    const { memberId, payer, firstName, lastName, dob, dependent, middleInitial, cpt4Id } = this.state.form
    const { showPatientSubscriber } = this.state
    let errors = {}
    if (!memberId && payer.requiredMemberId && step === 0) {
      const errorText = 'Member Id is not entered'
      errors = { ...errors, memberId: errorText }
      handleErrorMessageAlert(errorText)
    }
    if (!payer.value && step === 0) {
      const errorText = 'Insurance is not entered'
      errors = { ...errors, payer: errorText }
      handleErrorMessageAlert(errorText)
    }
    if (
      (showPatientSubscriber
        ? !(dependent && dependent.firstName)
        : !firstName) &&
      step === 1
    ) {
      const errorText = 'First Name is not entered'
      const name = showPatientSubscriber ? 'firstName2' : 'firstName'
      errors = { ...errors, [name]: errorText }
      handleErrorMessageAlert(errorText)
    }
    if (
      (showPatientSubscriber
        ? !(dependent && dependent.lastName)
        : !lastName) &&
      step === 1
    ) {
      const errorText = 'Last Name is not entered'
      const name = showPatientSubscriber ? 'lastName2' : 'lastName'
      errors = { ...errors, [name]: errorText }
      handleErrorMessageAlert(errorText)
    }
    if (
      (showPatientSubscriber
        ? !(dependent && dependent.middleInitial)
        : !middleInitial) &&
      step === 1
    ) {
      //  const errorText = 'MiddleInitial is not entered'
      //  const name = showPatientSubscriber ? 'middleInitial2' : 'middleInitial'
      //  errors = { ...errors, [name]: errorText }
      //  handleErrorMessageAlert(errorText)
    }
    if (
      (showPatientSubscriber ? dependent && dependent.dob : dob) &&
      step === 1
    ) {
      const [month, day, year] = dependent.dob.split('/')
      if (!(month && day && year) || !(year && year.length === 4)) {
        const name = showPatientSubscriber ? 'dob2' : 'dob'
        const errorText = 'Invalid Date of birth format'
        errors = { ...errors, [name]: errorText }
        handleErrorMessageAlert(errorText)
      }
    }
    if (
      (showPatientSubscriber ? !(dependent && dependent.dob) : !dob) &&
      payer.requiredMemberId &&
      step === 1
    ) {
      const errorText = 'Date of birth is not entered'
      const name = showPatientSubscriber ? 'dob2' : 'dob'
      errors = { ...errors, [name]: errorText }
      handleErrorMessageAlert(errorText)
    }
    if (
      (showPatientSubscriber
        ? !(dependent && (dependent.gender && dependent.gender.value))
        : !(dependent.gender && dependent.gender.value)) &&
      step === 1 && enableGender
    ) {
      const errorText = 'Gender is not entered'
      const name = showPatientSubscriber ? 'gender2' : 'gender'
      errors = { ...errors, [name]: errorText }
      handleErrorMessageAlert(errorText)
    }

    if (cpt4Id === undefined && step === 2) {
      const errorText = 'Procedure Code is not entered'
      handleErrorMessageAlert(errorText)
    }

  if (Object.entries(errors).length !== 0) {
      this.setState({ errors: { ...this.state.errors, ...errors } })
      return true
    }
    return false
  }

  nextPage = () => {
    // this.setState(({ currentStep }) => ({
    //   currentStep: currentStep >= 1 ? pages.length - 1 : currentStep + 1
    // }))
    const { currentStep } = this.state
    if (this.validateByStep(currentStep)) {
      return { currentStep }
    } else {
      this.setState(({ currentStep }) => {
        return {
          currentStep: currentStep >= 1 ? pages.length - 1 : currentStep + 1
        }
      })
    }
  }

  prevPage = () => {
    this.setState(({ currentStep }) => ({
      currentStep: currentStep <= 0 ? 0 : currentStep - 1
    }))
  }

  validate = () => {
    const stateForm: any = { ...this.state.form }
    const errors: any = {}
    const { dob, dependent = {} } = stateForm
    if (dob) {
      const [month, day, year] = dob.split('/')
      if (+month > 12 || +day > 31 || year.length < 4) {
        errors.dob = 'Invalid subscriber date of birth format'
      }
    }
    if (dependent && dependent.dob) {
      const [month, day, year] = dependent.dob.split('/')
      if (+month > 12 || +day > 31 || year.length < 4) {
        errors.dob2 = 'Invalid patient date of birth format'
      }
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ errors })
      const errorMessage = Object.values(errors)[0]
      if (typeof errorMessage === 'string') {
        handleErrorMessageAlert(errorMessage)
      }
    }
    return errors
  }
  onShowPatientSubscriberChange = (showPatientSubscriber: boolean) => {
    this.setState({ showPatientSubscriber })
  }
  createEstimate1 = () => {
    console.log("createEstimate1");
    const { showPatientSubscriber } = this.state
    const stateForm: any = { ...this.state.form }
    console.log("State" , stateForm);
    const errors = this.validate()
    console.log('showPatientSubscriber', showPatientSubscriber)
    if (Object.keys(errors).length > 0) {
      return
    }

    var cpt4Array = []
    if (stateForm.cpt4List) {
      // @ts-ignore
      cpt4Array = stateForm.cpt4List.map((cpt4Item, key) =>
        cpt4Item.cpt4Id 
      )
    }

    var appointmentArray = []
    if (stateForm.appintmentList) {
      // @ts-ignore
      appointmentArray = stateForm.appointmentList.map((appointmentItem, key) =>
        appointmentItem.appoinmentId
      )
    }

    if (cpt4Array.length === 0 && appointmentArray.length === 0) {
      handleErrorMessageAlert("Procedure Code is missing or invalid")
      return
    }

    const isSelfPay = !stateForm.payer.requiredMemberId;
    let DOB: any = stateForm.dob ? stateForm.dob : stateForm.dependent.dob
    if (!isSelfPay) {
        const [m, d, y] = DOB.split('/')
        DOB = new Date(`${y}-${m}-${d}`).toISOString()
    }
    const dependent: {
        dob?: string;
        firstName: string;
        middleInitial: string;
        lastName: string;
        gender?: string;
    } = {
      firstName: stateForm.dependent
        ? stateForm.dependent.firstName
        : stateForm.firstName,
      middleInitial: stateForm.dependent
        ? stateForm.dependent.middleInitial
        : stateForm.middleInitial,
      lastName: stateForm.dependent
        ? stateForm.dependent.lastName
        : stateForm.lastName,
    }
    if (enableGender) {
        dependent.gender =
            stateForm.dependent && stateForm.dependent.gender
                ? stateForm.dependent.gender.value
                : stateForm.gender.value
    }
    if (!isSelfPay) {
        dependent.dob =
            stateForm.dependent && stateForm.dependent.dob
                ? new Date(stateForm.dependent.dob).toISOString()
                : new Date(stateForm.dob).toISOString()
    }
    const { isAuthenticated } = this.props
    const form: any = {
      appointmentIdSet: stateForm.appointmentList ? appointmentArray : [],
      cpt4IdSet: stateForm.cpt4List ? cpt4Array : [],
      firstName: stateForm.firstName
        ? stateForm.firstName
        : stateForm.dependent.firstName,
      lastName: stateForm.lastName
        ? stateForm.lastName
        : stateForm.dependent.lastName,
      middleInitial: stateForm.middleInitial
        ? stateForm.middleInitial
        : stateForm.dependent.middleInitial,
      memberId: stateForm.payer.requiredMemberId ? stateForm.memberId : null,  // TODO: replace for real payers who does not need memberID
      serviceCode: stateForm.serviceCode,
      dob: DOB , /*stateForm.dob
        ? new Date(stateForm.dob).toISOString()
        : new Date(stateForm.dependent.dob).toISOString(),*/
      gender: stateForm.gender   ? stateForm.gender.value : null,
      relationship: stateForm.relationship
        ? stateForm.relationship.value
        : 'Self',
      physicianId: stateForm.physician ? stateForm.physician.value : null,
      dependentSearch: !showPatientSubscriber,
      dependent: showPatientSubscriber ? {} : dependent,
      eligibilityDate: new Date().toISOString(),
      insuranceCarrierId: stateForm.payer ? stateForm.payer.value : null,
      estimationType: 'OutPatientComplex',
      departmentId: DEPARTMENT_ID
    }
    console.log(form)
    // if (enableGender) {
    // }
    // console.log(form) // commit fun here
    // delete form.dependentSearch
    if (isAuthenticated) {
      console.log("Calling createEstimate", form);
      this.props.createEstimate(form)
    } else {
      console.log("Calling createPublicEstimate", form);
      this.props.createPublicEstimate(form)
    }
  }
  onScrollToBottom = (appointmentType: string, searchText?: string) => {
    const stateForm: any = { ...this.state.form }
    const { cpt4CodesSize, isFetchingCPT4Codes } = this.props
    if (!isFetchingCPT4Codes && searchText) {
      this.props.fetchCpt4Codes(stateForm.payer.value, cpt4CodesSize + 300, searchText)
    } else if (!isFetchingCPT4Codes && appointmentType === 'Procedure Code') {
      console.log("onScrollToBottom", this.props)
      this.props.fetchCpt4Codes(stateForm.payer.value, cpt4CodesSize + 300, searchText)
    }
  }
  render() {
    const { currentStep, showModal, errors, showPatientSubscriber } = this.state
    const {
      patients,
      relationships,
      genders,
      appointments,
      physicians,
      cpt4Codes,
      fetchAppointments,
      configuration
    } = this.props

    return (
      <WrapBlock>
        <HeadTitle>
          <Title>New Estimate</Title>
        </HeadTitle>

        <StepProgress>
          {breadCrumbs.map((label, i) => (
            <Step key={i} active={currentStep === i}>
              <Counter /> {label}
            </Step>
          ))}
        </StepProgress>
        <EstimateForm
          // @ts-ignore
          form={this.state.form}
          currentStep={currentStep}
          patients={patients}
          relationships={relationships}
          genders={genders}
          appointments={appointments}
          physicians={physicians}
          cpt4Codes={cpt4Codes}
          fetchAppointments={fetchAppointments}
          onSubmit={this.createEstimate1}
          onCancel={this.showModal}
          onNextPage={this.nextPage}
          onPrevPage={this.prevPage}
          onChangeInput={this.onChangeInput}
          onRemoveElement={this.onRemoveElement}
          errors={errors}
          onScrollToBottom={this.onScrollToBottom}
          configuration={configuration}
          onShowPatientSubscriberChange={this.onShowPatientSubscriberChange}
          showPatientSubscriberFromParent={showPatientSubscriber}
        />

        <Modal
          modal={{
            title: 'Leave Estimate',
            content: (
              <ModalContent>
                Are you sure you want to cancel this estimate? Your work will
                not be saved.
              </ModalContent>
            ),
            footer: (
              <Fragment>
                <Link variant={'text-danger'} to={routePath.ESTIMATES_PAGE}>
                  Leave
                </Link>
                <Button variant={'default'} onClick={this.onCloseModal}>
                  Keep Editing
                </Button>
              </Fragment>
            )
          }}
          isOpen={showModal}
        />
      </WrapBlock>
    )
  }
}

// tslint:disable-next-line:no-empty-interface
interface ReceivedProps { }

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = StateProps &
  DispatchProps &
  ReceivedProps &
  RouteComponentProps<any>

const mapStateToProps = (state: AppState) => ({
  isAccountCreated: state.auth.registrationData,
  error: state.estimates.error,
  isCreating: state.estimates.isFetchingCreate,
  relationships: state.references.relationships.data.map(item => ({
    value: item,
    label: camelCaseToSentence(item)
  })),
  genders: state.references.genders.data.map(item => ({
    value: item,
    label: camelCaseToSentence(item)
  })),
  appointments: state.references.appointments.data.content.map(item => ({
    value: item.id,
    label: item.description
  })),
  patients: state.references.patients.data.content.map(item => ({
    value: item.id,
    label: item.carrierName,
    requiredMemberId: item.requiredMemberId,
    fakeEligibility: item.fakeEligibility,
    dobRequired: item.dobRequired,
  })),
  physicians: state.references.physicians.data.content.map(item => ({
    value: item.id,
    label: item.name
  })),
  cpt4Codes: state.references.cpt4Codes.data.content.map(item => ({
    value: item.id,
    label: item.cpt4Code + ' - ' + item.description
  })),
  cpt4CodesSize: state.references.cpt4Codes.data.size,
  isFetchingCPT4Codes: state.references.cpt4Codes.isFetching,
  configuration: state.references.configuration,
  isAuthenticated: state.auth.isAuthenticated,
  publicEstimate: state.estimates.publicEstimate,
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      fetchAppointments,
      fetchRelationships,
      fetchGenders,
      fetchPatients,
      createEstimate,
      fetchPhysicians,
      fetchServiceAreas,
      fetchCpt4Codes,
      fetchConfiguration,
      createPublicEstimate
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EstimateCreatePage)
